const site = {
  name: 'Sri GDM Interior Industries',
  shortName: 'Sri GDM Interior Industries',
  tagline: 'Crafting Functional Spaces. Designing Timeless Interiors.',
  description:
    'Sri GDM is a premier interior design and woodworks firm delivering end-to-end interior solutions across residential and commercial sectors. We combine craftsmanship, precision machinery, and design thinking to create spaces that function beautifully.',
  address: {
    street: '187 H, Kandigaiperi Rd',
    area: 'Gnanadas Nagar',
    city: 'Valliyur',
    subArea: 'Vadakkuvalliyur',
    region: 'Tamil Nadu',
    postalCode: '627117',
    mapUrl: 'https://maps.app.goo.gl/sjRawfa8dAyiaMbo7',
    mapEmbed:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d813.2982326150901!2d77.61796345125249!3d8.40147723619509!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0467005787d8a9%3A0x44e41312fddb68a7!2sSRI%20GDM%20INTERIOR%20INDUSTRIES!5e1!3m2!1sen!2sin!4v1761000985836!5m2!1sen!2sin',
  },
  phones: [
    {
      number: '+919842084477',
      display: '+91 98420 84477',
    },
    {
      number: '+919842884477',
      display: '+91 98428 84477',
    },
  ],
  services: [
    {
      title: 'Modular Kitchens',
      description:
        'Transform your kitchen with our premium modular solutions featuring German hardware, efficient workflow designs, and smart storage systems. Serving homes across Valliyur, Tirunelveli and nearby areas, our expert team delivers contemporary kitchens that blend functionality with stunning aesthetics, perfect for modern South Indian homes.',
      locations: [
        'Valliyur',
        'Tirunelveli',
        'Nagercoil',
        'Panagudi',
        'Kalakad',
        'Eruvadi',
        'Thisaynavilai',
        'Vadakkankulam',
        'Kudankulam',
      ],
      featuredLocation: 'Valliyur',
    },
    {
      title: 'Wardrobes & Furniture',
      description:
        'Experience luxury living with our custom-designed wardrobes and furniture, tailored for Tamil Nadu homes. Using premium materials and innovative storage solutions, we create stunning pieces that maximize space while adding elegance to your home. Our designs consider the local climate and lifestyle needs of Valliyur and surrounding regions.',
      locations: [
        'Valliyur',
        'Tirunelveli',
        'Nagercoil',
        'Panagudi',
        'Kalakad',
        'Eruvadi',
        'Thisaynavilai',
        'Vadakkankulam',
        'Kudankulam',
      ],
      featuredLocation: 'Valliyur',
    },
    {
      title: 'False Ceilings & Soffits',
      description:
        'Elevate your interiors with our designer false ceiling solutions, perfect for the Tamil Nadu climate. From LED-integrated contemporary designs to classical coffered ceilings, we combine aesthetic appeal with practical features like improved acoustics and thermal insulation.',
      locations: [
        'Valliyur',
        'Tirunelveli',
        'Nagercoil',
        'Panagudi',
        'Kalakad',
        'Eruvadi',
        'Thisaynavilai',
        'Vadakkankulam',
        'Kudankulam',
      ],
      featuredLocation: 'Tirunelveli',
    },
    {
      title: 'Wall Panelling & Feature Walls',
      description:
        'Create stunning focal points with our premium wall paneling solutions, designed to withstand South Indian weather conditions. From modern designs to traditional patterns, we use materials from engineered wood to natural veneers, ensuring durability and style.',
      locations: [
        'Valliyur',
        'Tirunelveli',
        'Nagercoil',
        'Panagudi',
        'Kalakad',
        'Eruvadi',
        'Thisaynavilai',
        'Vadakkankulam',
        'Kudankulam',
      ],
      featuredLocation: 'Tirunelveli',
    },
    {
      title: 'Custom TV & Entertainment Units',
      description:
        'Upgrade your living space with our bespoke entertainment units, designed specifically for homes in Tamil Nadu. Popular among our clients in Valliyur and surrounding areas, our designs seamlessly integrate advanced cable management, adjustable shelving, and hidden storage while maintaining a sleek, modern aesthetic.',
      locations: [
        'Valliyur',
        'Tirunelveli',
        'Nagercoil',
        'Panagudi',
        'Kalakad',
        'Eruvadi',
        'Thisaynavilai',
        'Vadakkankulam',
        'Kudankulam',
      ],
      featuredLocation: 'Tirunelveli',
    },
    {
      title: 'Office & Commercial Fitouts',
      description:
        "Revolutionize your workplace with our end-to-end commercial interior solutions. From corporate offices to retail spaces in Valliyur and surrounding areas, we specialize in creating productive, ergonomic environments with modern amenities and collaborative spaces that reflect your company's vision.",
      locations: [
        'Valliyur',
        'Tirunelveli',
        'Nagercoil',
        'Panagudi',
        'Kalakad',
        'Eruvadi',
        'Thisaynavilai',
        'Vadakkankulam',
        'Kudankulam',
      ],
      featuredLocation: 'Tirunelveli',
    },
  ],
  work: 'Residential & Commercial Interiors',
  projects: [
    // Modular Kitchens
    {
      id: 'kitchen-1',
      title: 'Modern Kitchen Design',
      img: '/images/Modular Kitchen 01.jpg',
      category: 'Modular Kitchens',
      caption: 'Contemporary modular kitchen with island and premium finishes',
      location: 'Valliyur',
      completion: '2023',
    },
    {
      id: 'kitchen-2',
      title: 'Designer Kitchen',
      img: '/images/Modular Kitchen 02.jpg',
      category: 'Modular Kitchens',
      caption: 'Sleek modular kitchen with optimized storage solutions',
      location: 'Madurai',
      completion: '2024',
    },
    {
      id: 'kitchen-3',
      title: 'Premium Kitchen',
      img: '/images/Modular Kitchen 03.jpg',
      category: 'Modular Kitchens',
      caption: 'Elegant kitchen design with modern amenities',
      location: 'Kalakad',
      completion: '2024',
    },
    {
      id: 'kitchen-4',
      title: 'Luxury Kitchen Design',
      img: '/images/modular kitchen 04.JPG',
      category: 'Modular Kitchens',
      caption: 'Premium kitchen with high-end finishes and appliances',
      location: 'Eruvadi',
      completion: '2024',
    },

    // Office Interiors
    {
      id: 'office-1',
      title: 'Executive Office Space',
      img: '/images/office interior 01.jpg',
      category: 'Office Interiors',
      caption: 'Modern office design with collaborative spaces',
      location: 'Thisaynavilai',
      completion: '2023',
    },
    {
      id: 'office-2',
      title: 'Corporate Office Interior',
      img: '/images/Office interior 02.jpg',
      category: 'Office Interiors',
      caption: 'Contemporary office space with ergonomic design',
      location: 'Valliyur',
      completion: '2024',
    },
    {
      id: 'office-3',
      title: 'Modern Workspace',
      img: '/images/Office interior 03.jpg',
      category: 'Office Interiors',
      caption: 'Open-plan office with innovative design elements',
      location: 'Tirunelveli',
      completion: '2024',
    },

    // TV Units
    {
      id: 'tv-1',
      title: 'Contemporary TV Unit',
      img: '/images/tv unit 01.jpg',
      category: 'TV Units',
      caption: 'Modern TV unit with clean lines and storage',
      location: 'Tirunelveli',
      completion: '2024',
    },
    {
      id: 'tv-2',
      title: 'Entertainment Center',
      img: '/images/tv unit 02.jpg',
      category: 'TV Units',
      caption: 'Custom entertainment unit with ambient lighting',
      location: 'Vadakkankulam',
      completion: '2024',
    },
    {
      id: 'tv-3',
      title: 'Floating TV Console',
      img: '/images/tv unit 03.jpg',
      category: 'TV Units',
      caption: 'Minimalist floating TV unit design',
      location: 'Kudankulam',
      completion: '2024',
    },
    {
      id: 'tv-4',
      title: 'Media Wall Unit',
      img: '/images/tv unit 04.jpg',
      category: 'TV Units',
      caption: 'Integrated media wall with storage solutions',
      location: 'Tirunelveli',
      completion: '2024',
    },

    // Wall Paneling
    {
      id: 'wall-1',
      title: 'Designer Wall Panel',
      img: '/images/wall Paneling 01.jpg',
      category: 'Wall Panelling',
      caption: 'Textured wall panel with modern patterns',
      location: 'Chennai',
      completion: '2024',
    },
    {
      id: 'wall-2',
      title: 'Accent Wall Design',
      img: '/images/wall Paneling 02.jpg',
      category: 'Wall Panelling',
      caption: 'Contemporary wall paneling with lighting',
      location: 'Coimbatore',
      completion: '2024',
    },
    {
      id: 'wall-3',
      title: 'Feature Wall',
      img: '/images/wall Paneling 03.jpg',
      category: 'Wall Panelling',
      caption: 'Decorative wall panel installation',
      location: 'Tirunelveli',
      completion: '2024',
    },
    {
      id: 'wall-4',
      title: 'Modern Wall Treatment',
      img: '/images/wall Paneling 04.jpg',
      category: 'Wall Panelling',
      caption: 'Custom wall paneling with geometric design',
      location: 'Tirunelveli',
      completion: '2024',
    },

    // Wardrobes & Storage
    {
      id: 'wardrobe-1',
      title: 'Built-in Wardrobe',
      img: '/images/Wardrobes & Storage 01.jpg',
      category: 'Wardrobes & Storage',
      caption: 'Custom built-in wardrobe with optimized storage',
      location: 'Nagercoil',
      completion: '2024',
    },
    {
      id: 'wardrobe-2',
      title: 'Walk-in Closet',
      img: '/images/Wardrobes & Storage 02.jpg',
      category: 'Wardrobes & Storage',
      caption: 'Luxury walk-in closet design',
      location: 'Panagudi',
      completion: '2024',
    },
    {
      id: 'wardrobe-3',
      title: 'Modern Storage Solution',
      img: '/images/Wardrobes & Storage 03.jpg',
      category: 'Wardrobes & Storage',
      caption: 'Contemporary wardrobe with smart organization',
      location: 'Nagercoil',
      completion: '2024',
    },
    {
      id: 'wardrobe-4',
      title: 'Designer Wardrobe',
      img: '/images/Wardrobes & Storage 04.jpg',
      category: 'Wardrobes & Storage',
      caption: 'Premium wardrobe with modern finishes',
      location: 'Tirunelveli',
      completion: '2024',
    },

    // False Ceilings
    {
      id: 'ceiling-1',
      title: 'Modern False Ceiling',
      img: '/images/False Ceilings 01.JPG',
      category: 'False Ceilings',
      caption: 'Contemporary ceiling design with LED lighting integration',
      location: 'Tirunelveli',
      completion: '2024',
    },
    {
      id: 'ceiling-2',
      title: 'Elegant Ceiling Design',
      img: '/images/False Ceilings 02.jpg',
      category: 'False Ceilings',
      caption: 'Multi-level ceiling with premium finishes',
      location: 'Tirunelveli',
      completion: '2024',
    },
    {
      id: 'ceiling-3',
      title: 'Luxury Ceiling Treatment',
      img: '/images/False Ceilings 03.JPG',
      category: 'False Ceilings',
      caption: 'Designer ceiling with innovative lighting solutions',
      location: 'Tirunelveli',
      completion: '2024',
    },
  ],
  team: [
    {
      name: 'Ramesh',
      role: 'Founder & Lead Designer',
      photo: '/images/processed/misc/proj-3386-800x600.jpg',
    },
    {
      name: 'Anita',
      role: 'Head of Production',
      photo: '/images/processed/misc/proj-3375-800x600.jpg',
    },
    {
      name: 'Vikram',
      role: 'Project Manager',
      photo: '/images/processed/misc/proj-3478-800x600.jpg',
    },
  ],
  testimonials: [
    {
      name: 'Mrs. Dhanalakshmi Suresh',
      gender: 'female',
      text: "Exceptional workmanship and timely delivery — our kitchen looks stunning. The team's attention to detail exceeded our expectations.",
      location: 'Nanguneri',
      project: 'Modular Kitchen',
    },
    {
      name: 'Mr. Shankar Raman',
      gender: 'male',
      text: 'Professional and detail-oriented team; they understood our requirements perfectly. Our home interiors have been transformed beautifully.',
      location: 'Panagudi',
      project: 'Home Interiors',
    },
    {
      name: 'Mrs. Alamelu Natarajan',
      gender: 'female',
      text: 'The wardrobe solutions they provided maximized our storage space while maintaining a sleek, modern look. Excellent craftsmanship!',
      location: 'Kalakad',
      project: 'Custom Wardrobes',
    },
    {
      name: 'Mr. Anand Krishnan',
      gender: 'male',
      text: 'From concept to completion, GDM Interior Industries delivered exactly what we envisioned for our home. The space is both functional and aesthetically pleasing.',
      location: 'Nagercoil',
      project: 'Complete Home Interior',
    },
    {
      name: 'Mrs. Vasanthi Kumaran',
      gender: 'female',
      text: 'Their TV unit design completely transformed our living room. The quality of materials and finishing is outstanding.',
      location: 'Valliyur',
      project: 'Entertainment Unit',
    },
    {
      name: 'Mr. Chandrasekhar',
      gender: 'male',
      text: 'The false ceiling work they did in our home is stunning. The LED lighting integration is perfect and the execution was very professional.',
      location: 'Tirunelveli',
      project: 'False Ceiling',
    },
  ],
  hours: 'Mon - Fri: 09:00 - 18:00',
};

export default site;
